export default __webpack_public_path__ + "static/media/libraryIcon.47428b4f.svg";